import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BuildingStatus } from '../land/state'
import { initialCastle3State, Castle3State } from './state'

export const castle3Slice = createSlice({
  name: 'castle3',
  initialState: initialCastle3State as Castle3State,
  reducers: {
    setCastle3Loading: (state: Castle3State, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setCastle3ImmediateLoading: (state: Castle3State, action: PayloadAction<boolean>) => {
      state.isImmediate = action.payload
    },
    setCastle3Error: (state: Castle3State, action: PayloadAction<string | undefined>) => {
      state.error = action.payload
    },
    setCastle3BuildingStatus: (state: Castle3State, action: PayloadAction<Partial<BuildingStatus>>) => {
      const existingStatus = state.buildingStatus || initialCastle3State.buildingStatus
      const payload = action.payload
      
      const mergedStatus = { ...existingStatus } as Partial<BuildingStatus>
      
      for (const key in payload) {
        if (payload[key as keyof BuildingStatus]) {
          const existingBuilding = existingStatus[key as keyof BuildingStatus]
          const payloadBuilding = payload[key as keyof BuildingStatus]
          if (existingBuilding) {
            mergedStatus[key as keyof BuildingStatus] = {
              ...existingBuilding,
              ...payloadBuilding,
              hp: Number(payloadBuilding?.hp ?? 0),
              maxHp: Number(payloadBuilding?.maxHp ?? 0),
            } as any
          } else {
            mergedStatus[key as keyof BuildingStatus] = {
              ...payloadBuilding,
              hp: Number(payloadBuilding?.hp ?? 0),
              maxHp: Number(payloadBuilding?.maxHp ?? 0),
            } as any
          }
        }
      }
      
      state.buildingStatus = mergedStatus
    },
    setCastle3RepairRequirements: (state: Castle3State, action: PayloadAction<{ ecsToken: number; gem: number; stone: number; wood: number }>) => {
      state.repairRequirements = action.payload
    },
    setCastle3RestoreBuilding: (state: Castle3State) => {
      state.isRestored = true
    },
    setCastle3FetchSupportCharacters: (state: Castle3State, action: PayloadAction<any[]>) => {
      state.supportCharacters = action.payload
    },
    setCastle3SupportCharacters: (state: Castle3State, action: PayloadAction<any[]>) => {
      state.supportCharacters = [...state.supportCharacters, ...action.payload]
      state.isSetSupportCharacterSuccess = true
    },
    setCastle3ClearStatus: (state: Castle3State) => {
      state.isSetSupportCharacterSuccess = false
      state.error = undefined
    },
    setCastle3SupportState: (state: Castle3State, action: PayloadAction<boolean>) => {
      state.supportState = action.payload
    },
    setCastle3UpgradeBuilding: (state: Castle3State) => {
      state.upgradeAvailable = false
    },
    setCastle3UpgradeRequirements: (state: Castle3State, action: PayloadAction<{ ecsToken: number }>) => {
      state.upgradeRequirements = action.payload
    },
    setCastle3UpgradeAvailable: (state: Castle3State, action: PayloadAction<boolean>) => {
      state.upgradeAvailable = action.payload
    },
    setCastle3RemoveCharacterFromBuilding: (state: Castle3State, action: PayloadAction<{ success: boolean; building: string; character: string }>) => {
      // Handle character removal if needed
    },
    setCastle3AddCharacterToBuilding: (state: Castle3State, action: PayloadAction<{ success: boolean; building: string; character: string }>) => {
      // Handle character addition if needed
    },
    setCastle3AllMiningStatus: (state: Castle3State, action: PayloadAction<any>) => {
      state.allMiningStatus = action.payload
    },
  },
})

export const {
  setCastle3Loading,
  setCastle3ImmediateLoading,
  setCastle3Error,
  setCastle3BuildingStatus,
  setCastle3RepairRequirements,
  setCastle3RestoreBuilding,
  setCastle3FetchSupportCharacters,
  setCastle3SupportCharacters,
  setCastle3ClearStatus,
  setCastle3SupportState,
  setCastle3UpgradeBuilding,
  setCastle3UpgradeRequirements,
  setCastle3UpgradeAvailable,
  setCastle3RemoveCharacterFromBuilding,
  setCastle3AddCharacterToBuilding,
  setCastle3AllMiningStatus,
} = castle3Slice.actions

export default castle3Slice.reducer

